import '../styles/HeaderHomeOut.css'
import condicionesGenerales from "../../../../assets/docs/Condiciones Generales.pdf"

const HeadHomeOut = () => {

    const downloadCondicionesGenerales = () => {
        const downloadLink = document.createElement("a");
        downloadLink.href = condicionesGenerales
        downloadLink.download = "Condiciones Generales.pdf"
        downloadLink.click()
    }

    return (
        <>
            {/* mobil */}
            <div className="container-fluid banner pe-0 ps-0 d-block d-lg-none ">
                {/* <div className="container-xxl pe-0 ps-0"> */}
                    <div className="row me-0 ">
                        <div className="col-12 col-md-6 pt-lg-4 pe-0">
                            <div style={{ backgroundColor: '#91DDF8' }}>
                                <img src='/assets/img/homeout/img-banner-homeoutheader-(2).png' className="banner__image d-block d-md-none" alt='' />
                            </div>
                            <div className="banner__text__center  ">
                                <h5 className="banner__title"><b>¡Hola!</b></h5>
                                <p className="banner__text pe-3 mt-3 pb-3">Conozcamos juntos todo lo relacionado con tu Seguro de Vida y Desempleo</p>
                                <button className="banner__button " onClick={downloadCondicionesGenerales}>Descarga aquí las condiciones</button>
                            </div>

                            <div className="banner__footer my-5 align-items-center d-flex d-md-none">
                                <div className=" banner__footer__text pe-3">
                                    <p>Llama sin costo: <span><b><a href='tel:800 801 0132'>800 801 0132</a></b></span></p>
                                    <p>Horarios de atención:</p>
                                    <p>Lun a sáb de 09:00 a 18:00 hrs.</p>
                                </div>
                                <div className="text-center ps-3">
                                    <p><a className=' leelawadee_bold ' href='mailto:sac_mx@cardif.com.mx' style={{ fontSize: '1.2rem' }} ><strong>sac_mx@cardif.com.mx</strong></a></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 d-none d-md-block pe-lg-0">
                            <img src='/assets/img/homeout/img-banner-homeoutheader-(2).png' className="banner__image" alt='' />
                        </div>
                    </div>

                   
            </div>
            {/* desktop */}
            <div className='home p-0 d-none d-lg-block '> 
                <div className='container-cookie bannerInicial '>
                    <div className='row bannerI '>

                        <div className='col-12 col-md-6 col-back '>
                            <div className='home__text-container'>                              
                                <div className='home__title'>
                                    <h2>¡Hola!</h2>
                                </div>
                                <div className='home__text'>
                                    <p className=''>Conozcamos juntos todo lo relacionado con tu <br />Seguro de Vida y Desempleo</p>
                                </div>
                                <div className=''>
                                    <button className='btn__success' onClick={downloadCondicionesGenerales}>DESCARGAR CONDICIONES GENERALES</button>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-6 col-image p-0'>
                            <div className='home__image-container'>
                                <img src='/assets/img/homeout/img-banner-homeoutheader-(3).png' className="home__image_desks  m-1 w-100 " alt='' style={{}} />
                            </div>
                        </div>
              
                    </div>
                </div>
            </div>
            <div className='head__footer d-none d-lg-grid '>
                <p> Llama sin costo: </p> 
                <p><b><a href='tel:800 801 0132'>800 801 0132</a></b></p>
                <div className='separacion border'></div>
                <p>Horarios de atención: Lunes a sábados de 09:00 a 18:00 hrs.</p>
                <div className='separacion border'></div>
                <p ><a role='button' href="mailto:sac_mx@cardif.com.mx" className='fw-bold ' >sac_mx@cardif.com.mx</a></p>
            </div>
        </>
    )
}

export default HeadHomeOut